import React, { Component } from "react";
import ReactDOM from "react-dom";
import App from "./mobioastro/containers/app";
import registerServiceWorker from "./registerServiceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "./redux/configureStore";
import { IntlProvider, addLocaleData } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectLanguage } from "./redux/actions/header/action";
import { setLanguage } from "./utils/helper";

import axios from "axios";

import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import el from "react-intl/locale-data/el";
import ee from "react-intl/locale-data/ee";
import nl from "react-intl/locale-data/nl";
import fr from "react-intl/locale-data/fr";
import ar from "react-intl/locale-data/ar";
import hu from "react-intl/locale-data/hu";
import no from "react-intl/locale-data/no";
import pl from "react-intl/locale-data/pl";
import vi from "react-intl/locale-data/vi";
import se from "react-intl/locale-data/se";
import cy from "react-intl/locale-data/cy";
import ro from "react-intl/locale-data/ro";
import messages_es from "./utils/horosope_es.json";
import messages_gr from "./utils/horoscope_gr.json";
import messages_ee from "./utils/horoscope_ee.json";
import messages_nl from "./utils/horoscope_nl.json";
import messages_fr from "./utils/horoscope_fr.json";
import messages_ar from "./utils/horoscope_ar.json";
import messages_hu from "./utils/horoscope_hu.json";
import messages_no from "./utils/horoscope_no.json";
import messages_pl from "./utils/horoscope_pl.json";
import messages_vn from "./utils/horoscope_vn.json";
import messages_se from "./utils/horoscope_se.json";
import messages_cy from "./utils/horoscope_cy.json";
import messages_ro from "./utils/horoscope_ro.json";
// import messages_en from "./translations/en.json";

addLocaleData([
  ...en,
  ...es,
  ...el,
  ...ee,
  ...nl,
  ...fr,
  ...ar,
  ...hu,
  ...no,
  ...pl,
  ...vi,
  ...se,
  ...cy,
  ...ro,
]);

const messages = {
  mx: messages_es,
  es: messages_es,
  gr: messages_gr,
  ee: messages_ee,
  nl: messages_nl,
  fr: messages_fr,
  eg: messages_ar,
  hu: messages_hu,
  ps: messages_ar,
  no: messages_no,
  jo: messages_ar,
  pl: messages_pl,
  vn: messages_vn,
  se: messages_se,
  rs: messages_cy,
  ro: messages_ro,
};

var localMessage;
// let localLanguage = '';
// if (countryCode === 'mx') {
//     localLanguage = 'es'
// } else if (countryCode === 'gr') {
//     localLanguage = 'el'
// } else if (countryCode === 'eg' || countryCode === 'ps' || countryCode === 'jo') {
//     localLanguage = 'ar'
// }
// else if (countryCode == 'ie') {
//     localLanguage = 'en'
// }
// else if (countryCode == 'pl') {
//     localLanguage = 'pl'
// }
// else if (countryCode == 'vn') {
//     localLanguage = 'vi'
// }
// else {
//     localLanguage = countryCode
// }

class LangWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      localMessage: null,
    };
  }

  componentWillMount() {
    var url_string = window.location.hostname;
    var countryCode = url_string.split(".")[0];
    if (window.location.href.indexOf("local") >= 0) countryCode = "za";
    let newCountryCode;
    if (countryCode === "be") {
      newCountryCode = "nl";
    } else if (countryCode === "dz") {
      newCountryCode = "fr";
    } else if (countryCode === "gr-mobimilia") {
      newCountryCode = "gr";  
    } else {
      newCountryCode = countryCode;
    }
    this.props.selectLanguage(newCountryCode);
    sessionStorage.setItem(
      "countryCode",
      JSON.stringify({ countryCode: newCountryCode })
    );
    let localLang = setLanguage(newCountryCode);
    sessionStorage.setItem("lang", localLang);

    // axios.post(`https://${newCountryCode}.mobioastro.com/api/getSiteContent`, {
    //     CountryCode: localLang,
    //   },{
    //       headers:{
    //         "Access-Control-Allow-Origin": "*"
    //       }
    //   })
    //   .then( (response) =>{
    //     let data = response.data.data;
    //     localMessage = data.reduce((obj, item) => Object.assign(obj, { [item.TextKey]: item.OtherLangText }), {});
    //         console.log("localMessage",localMessage)
    //         this.setState({
    //             localMessage:localMessage
    //         })
    //     })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  render() {
    const { countryCode, localLanguage } = this.props;
    const { localMessage } = this.state;
    console.log("localMessage====>", localLanguage, localMessage);
    return (
      <IntlProvider
        locale={localLanguage}
        messages={
          localMessage && Object.keys(localMessage).length > 0
            ? localMessage
            : messages[countryCode]
        }
      >
        <App
          countryCode={countryCode}
          localLanguage={localLanguage}
          messages={localMessage}
        />
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    countryCode: state.HeaderReducer.countryCode,
    localLanguage: state.HeaderReducer.localLanguage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectLanguage: bindActionCreators(selectLanguage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LangWrapper);



// WEBPACK FOOTER //
// ./src/LangWarppper.js